import * as React from "react";

interface IAppContextInterface {
  state: {
    drawerOpen: boolean;
  };
  toggleDrawer(): void;
}

interface IProps {
  children: React.ReactNode;
}

interface IState {
  drawerOpen: boolean;
}

const ctxt = React.createContext<IAppContextInterface | any>(null);

const AppContextProvider = ctxt.Provider;
export const AppContextConsumer = ctxt.Consumer;

export default class MyProvider extends React.Component<IProps, IState> {
  state: IState = {
    drawerOpen: false
  };

  toggleDrawer = () => {
    this.setState({ drawerOpen: !this.state.drawerOpen });
  };

  render() {
    return (
      <AppContextProvider
        value={{
          state: this.state,
          toggleDrawer: () => this.toggleDrawer()
        }}
      >
        {this.props.children}
      </AppContextProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/ContextProvider.tsx